export default __webpack_public_path__ + "static/media/cross-icon.0e100cd0.svg";